/* ==========================================================
   TRADIENET KNOWLEDGE SYSTEM v2
   ========================================================== */

document.addEventListener("DOMContentLoaded", function () {

    /* ==========================================================
       FAQ ACCORDION
    ========================================================== */

    const faqItems = document.querySelectorAll(".tn-faq-item");

    faqItems.forEach((item) => {

        const question = item.querySelector(".tn-faq-question");

        if (!question) return;

        question.addEventListener("click", function () {

            faqItems.forEach((faq) => {

                if (faq !== item) {
                    faq.classList.remove("active");
                }

            });

            item.classList.toggle("active");

        });

    });

    /* ==========================================================
       SMOOTH SCROLL FOR TOC LINKS
    ========================================================== */

    document.querySelectorAll('.tn-toc a[href^="#"]').forEach(anchor => {

        anchor.addEventListener("click", function (e) {

            e.preventDefault();

            const target = document.querySelector(this.getAttribute("href"));

            if (!target) return;

            target.scrollIntoView({

                behavior: "smooth",

                block: "start"

            });

        });

    });

    /* ==========================================================
       READING PROGRESS BAR
    ========================================================== */

    const progress = document.createElement("div");

    progress.id = "tn-progress";

    document.body.appendChild(progress);

    function updateProgress() {

        const article = document.querySelector(".tn-article");

        if (!article) return;

        const rect = article.getBoundingClientRect();

        const articleTop = window.scrollY + rect.top;

        const articleHeight = article.offsetHeight;

        const scroll = window.scrollY;

        const viewport = window.innerHeight;

        const percent = Math.min(
            100,
            Math.max(
                0,
                ((scroll - articleTop + 100) / (articleHeight - viewport + 200)) * 100
            )
        );

        progress.style.width = percent + "%";

    }

    window.addEventListener("scroll", updateProgress);

    window.addEventListener("resize", updateProgress);

    updateProgress();

    /* ==========================================================
       ACTIVE TABLE OF CONTENTS
    ========================================================== */

    const tocLinks = document.querySelectorAll(".tn-toc a");

    const headings = [];

    tocLinks.forEach(link => {

        const id = link.getAttribute("href");

        if (!id) return;

        const target = document.querySelector(id);

        if (target) {

            headings.push({

                link,

                target

            });

        }

    });

    function updateTOC() {

        let current = null;

        headings.forEach(item => {

            const top = item.target.getBoundingClientRect().top;

            if (top <= 140) {

                current = item;

            }

        });

        tocLinks.forEach(link => {

            link.classList.remove("active");

        });

        if (current) {

            current.link.classList.add("active");

        }

    }

    window.addEventListener("scroll", updateTOC);

    updateTOC();

    /* ==========================================================
       FADE IN CONTENT
    ========================================================== */

    const animated = document.querySelectorAll(
        ".tn-tip,.tn-warning,.tn-note,.tn-related-card,.tn-author,.tn-cta"
    );

    const observer = new IntersectionObserver(

        entries => {

            entries.forEach(entry => {

                if (entry.isIntersecting) {

                    entry.target.style.opacity = 1;

                    entry.target.style.transform = "translateY(0px)";

                }

            });

        },

        {

            threshold: 0.15

        }

    );

    animated.forEach(el => {

        el.style.opacity = 0;

        el.style.transform = "translateY(30px)";

        el.style.transition = ".5s ease";

        observer.observe(el);

    });

});